import { createBrowserRouter } from "react-router-dom";
import Root from "../Layout/Root";
// Authentication
import SignIn from "../pages/Login/SignIn";
import ForgotPassword from "../pages/Login/ForgotPassword";
import SetNewPassword from "../pages/Login/SetNewPassword";

// Error Pages
import ServerError from "../error/ServerError";
import ErrorPage from "../error/Error";
// Nav Pages
import ManageTags from "../pages/ManageTags/ManageTags";
import ManageArtists from "../pages/ManageArtists/ManageArtists";
import ManageRemixers from "../pages/ManageRemixers/ManageRemixers";
import ManageOnetimeCoupons from "../pages/CouponCodes/ManageOnetimeCoupons";
import ManageUnlimitedCoupons from "../pages/CouponCodes/ManageUnlimitedCoupons";
import SubscriptionReport from "../pages/ManageReports/SubscriptionReport";
import DownloadsReport from "../pages/ManageReports/DownloadsReport";
import Chart from "../pages/ManageCharts/Charts";
// import AdminLogs from "../pages/AdminLogs/AdminLogs";
// import ActiveSessions from "../pages/ActiveSessions/ActiveSessions";
import UserMonitoring from "../pages/UserMonitoring/UserMonitoring";

import AddTrackForm from "../pages/AddTracks/AddTrackForm";
import MyTracks from "../pages/MyTracks/MyTracks";
import MyPlaylists from "../pages/MyPlaylists/MyPlaylists";
// import {
//   ProtectAdminRoute,
//   ProtectCommonRoute,
//   ProtectedRoute,
//   ProtectRemixerRoute,
//   PublicRoute,
// } from "../components/protectedAndPublicRoute";
import AddNewRemixerUser from "../pages/ManageRemixers/AddNewRemixerUser";
import {
  ProtectAdminRoute,
  ProtectCommonRoute,
  ProtectedRoute,
  ProtectRemixerRoute,
  PublicRoute,
} from "../components/protectedAndPublicRoute";

// Create a component that renders the appropriate dashboard based on user role
import { useSelector } from "react-redux";
import { roles } from "../constants/commonConstants";
import TrackManagement from "../pages/AddTracks/TrackManagement";

import ManageCustomers from "../pages/ManageCustomers/ManageCustomers";
import CustomerViewDetails from "../pages/ManageCustomers/CustomerViewDetails";
import PendingCustomerRequests from "../pages/ManageCustomers/PendingCustomerRequests";
import RemixerOverview from "../pages/ManageRemixers/RemixerOverview";
import SetRemixerPassword from "../pages/ManageRemixers/SetRemixerPassword";
import ViewRemixerUser from "../pages/ManageRemixers/ViewRemixerUser";
import ManageTop10Edits from "../pages/TopEdits/ManageTop10Edits";
import AddNewPlaylist from "../pages/ManagePlaylist/AddNewPlaylist";
import SubcategoryManager from "../pages/ManagePlaylist/SubcategoryManager";
import PlaylistManagement from "../pages/ManagePlaylist/PlaylistManagement";
import ManageOnetimeAmountCoupons from "../pages/CouponCodes/ManageOnetimeAmountCoupons";
import ManageUnlimitedAmountCoupons from "../pages/CouponCodes/ManageUnlimitedAmountCoupons ";
import BannerManagement from "../pages/BannerManagement/BannerManagement";
import AdminCouponManagement from "../pages/AdminCoupon/AdminCoupon";
import ProducerCategoryManager from "../pages/ManageProducerCategory/ProducerCategoryManager";
import ManageProducerTag from "../pages/ManageProducerTag/ManageProducerTag";
import ProducerPackManagement from "../pages/ManageProducerPack/ProducerPackManagement";
import AddNewProducerPack from "../pages/ManageProducerPack/AddNewProducerPack";
import DownloadTracking from "../pages/DownloadTracking/DownloadTracking";
import ConsentLogs from "../pages/ConsentLogs/ConsentLogs";
import BreachNotification from "../pages/BreachNotification/BreachNotification";

const Dashboard = () => {
  const { role } = useSelector((state) => state.auth);

  if (role === roles.ADMIN) {
    return <TrackManagement />;
  } else if (role === roles.REMIXER) {
    return <TrackManagement />;
  }

  return null; // or a default component
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      // Dashboard route - handles both admin and remixer home pages
      {
        path: "",
        element: <ProtectedRoute />,
        children: [
          {
            path: "",
            element: <Dashboard />,
          },
        ],
      },

      // Admin-only routes
      {
        element: <ProtectAdminRoute />,
        children: [
          {
            path: "/manage-tags", // Give it a specific path
            element: <ManageTags />,
          },
          {
            path: "/manage-artist",
            element: <ManageArtists />,
          },
          {
            path: "/manage-track",
            element: <TrackManagement />,
          },
          {
            path: "/manage-remixers",
            element: <ManageRemixers />,
          },
          {
            path: "/onetime-coupon-codes",
            element: <ManageOnetimeCoupons />,
          },
          {
            path: "/unlimited-coupon-codes",
            element: <ManageUnlimitedCoupons />,
          },
          {
            path: "/onetime-amount-coupon-codes",
            element: <ManageOnetimeAmountCoupons />,
          },
          {
            path: "/unlimited-amount-coupon-codes",
            element: <ManageUnlimitedAmountCoupons />,
          },
          {
            path: "/subscription-report",
            element: <SubscriptionReport />,
          },
          {
            path: "/download-report",
            element: <DownloadsReport />,
          },
          {
            path: "/manage-playlist-add-new-playlist",
            element: <AddNewPlaylist />,
          },
          {
            path: "/edit-playlist/:id",
            element: <AddNewPlaylist />,
          },
          {
            path: "/manage-playlist-subcategoryManager",
            element: <SubcategoryManager />,
          },
          {
            path: "/manage-playlist",
            element: <PlaylistManagement />,
          },
          {
            path: "/remixer-overview",
            element: <RemixerOverview />,
          },

          {
            path: "/manage-customer",
            element: <ManageCustomers />,
          },
          {
            path: "customer/:customerId",
            element: <CustomerViewDetails />,
          },
          {
            path: "/pending-requests",
            element: <PendingCustomerRequests />,
          },
          {
            path: "/add-tracks/:id",
            element: <AddTrackForm />,
          },
          {
            path: "/add-tracks",
            element: <AddTrackForm />, // Create new track
          },
          {
            path: "/remixer-user/add",
            element: <AddNewRemixerUser />,
          },
          {
            path: "/remixer-user/edit/:id",
            element: <AddNewRemixerUser />,
          },
          {
            path: "/remixer-user/view/:id",
            element: <ViewRemixerUser />,
          },
          {
            path: "/top-edits",
            element: <ManageTop10Edits />,
          },
          {
            path: "/banner-management",
            element: <BannerManagement />,
          },
          {
            path: "/chart-management",
            element: <Chart />,
          },
          {
            path: "/cookie-consent-log",
            element: <ConsentLogs />,
          },
          {
            path: "/landing-coupon-management",
            element: <AdminCouponManagement />,
          },
          {
            path: "/producer-category-management",
            element: <ProducerCategoryManager />,
          },
          {
            path: "/producer-tag-management",
            element: <ManageProducerTag />,
          },
          {
            path: "/manage-producer-packs",
            element: <ProducerPackManagement />,
          },
          {
            path: "/add-producer-pack",
            element: <AddNewProducerPack />,
          },
          {
            path: "/edit-producer-pack/:id",
            element: <AddNewProducerPack />,
          },
          {
            path: "/download-tracking",
            element: <DownloadTracking />,
          },
          {
            path: "/user-monitoring",
            element: <UserMonitoring />,
          },
          {
            path: "/breach-notification",
            element: <BreachNotification />,
          },
        ],
      },

      // Remixer-only routes
      {
        element: <ProtectRemixerRoute />,
        children: [
          {
            path: "/my-tracks", // Give it a specific path
            element: <MyTracks />,
          },
          {
            path: "/remixer-manage-track",
            element: <TrackManagement />,
          },
          {
            path: "/remixer-tags",
            element: <ManageTags />,
          },
          {
            path: "/remixer-manage-tags",
            element: <ManageTags />,
          },
          {
            path: "/remixer-artists",
            element: <ManageArtists />,
          },
          {
            path: "/remixer-tracks",
            element: <TrackManagement />,
          },
          {
            path: "/remixer-add-tracks",
            element: <AddTrackForm />, // Create new track
          },
          {
            path: "/remixer-add-tracks/:id",
            element: <AddTrackForm />,
          },
          {
            path: "/my-playlists",
            element: <MyPlaylists />,
          },
          {
            path: "/profile",
            element: <ViewRemixerUser />,
          },
        ],
      },

      // Common Routes (Both Admin and Remixer)
      //       {
      //         element: <ProtectCommonRoute />,
      //         children: [
      //           {
      //             path: "/add-tracks",
      //             element: <AddTrackForm />,
      //           },
      //         ],
      //       },
    ],
  },
  // NOTE: AUTHENTICATION
  {
    path: "signin",
    element: <SignIn />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "reset-password",
    element: <SetNewPassword />,
  },
  // NOTE: 500
  {
    path: "/server-error",
    element: <ServerError />,
  },
  // NOTE: 404
  {
    path: "*",
    element: <ErrorPage />,
  },
  {
    path: "/set-password",
    element: <SetRemixerPassword />,
  },
]);

export default router;
